import React, { useEffect, useState } from 'react';
import getQueryStringParams from "../utils/urlParameters";

const Login = (props) => {

    function handleOnCallbackEvent(event) {
        const eventDetail = event.detail;

        switch (eventDetail.name) {
            case 'redirect':
                const url = eventDetail.data.url;
                window.location.href = url;
                break;
        }
    }

    function addEventListeners() {
        const sankhyaLogin = document.querySelector('sankhya-login');
        sankhyaLogin.addEventListener('onCallbackEvent', handleOnCallbackEvent);
    }

    function getRouteUrl() {
        let path = window.location.pathname;

        if(path === "/" ){
            return null;
        }

        return path;
    }

    function getStepUrl() {
        let stepParam = {};
        const search = window.location.search + window.location.hash;
        let { step } = getQueryStringParams(search);
        return step;
    }

    function getParamsUrl() {

        let params = {};

        const search = window.location.search + window.location.hash;        
        // const redirectUrlLogin = window.location.origin;
        let { redirect_to, application_id, redirect_zendesk, sas, createid, token, hide, source } = getQueryStringParams(search);

        if (redirect_to) {
            params = { ...params, redirect_to: redirect_to };
            // setCurrentParams({redirect_to: redirect_to});
        }

        if (application_id) {
            params = {...params, application_id: application_id };
            // setApplicationId(application_id);
        }

        if (redirect_zendesk) {
            params = {...params, redirect_zendesk: redirect_zendesk };
            // setRedirectZendesk(redirect_zendesk);
        }

        if (sas) {
            params = {...params, sas: sas };
            // setSas(sas);
        }

        if (token) {
            params = {...params, token: token };
        }

        //TODO: verificar se faz sentido, pois o componente já faz esse direcionamento
        // if (redirectUrlLogin) {
        //     setRedirectLogin(redirectUrlLogin);
        // }

        if (createid) {
            params = {...params, createid: createid };
            // setCreateId(search);
        }

        if (hide) {
            params = {...params, hide: hide };
        }

        if (source) {
            params = {...params, source: source };
        }

        //TODO: verificar se faz sentido, pois o componente já faz esse direcionamento
        //
        // if (search.match(/messagesankhyaom/)){
        //     setMessageSankhyaOm(search);
        // }
        
        return JSON.stringify(params);
    }

    useEffect(() => {
        addEventListeners();
    }, []);

    return (
        <sankhya-login route={getRouteUrl()} step={getStepUrl()} params={getParamsUrl()}/>
    )
}

export default Login;
